<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Customer Subscriptions</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_customer_subscription: 'add_customer_subscription',
            delete_customer_subscription: 'delete_customer_subscription',
          }"
          :removeAddButton="true"
          :deleteAllSubscriptionButton="true"
          :deleteAllCustomerSubscription="deleteAllCustomerSubscription"
          :addEditCustomerSubscription="true"
          :removeWarehouseDeliverButton="true"
          :openAddEditCustomerSubscriptionModal="openAddEditCustomerSubscriptionModal"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :columns="columns"
          :hideSelectingColumn="true"
          :removeFromToDate="true"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
            class="customer-subscription-table"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.user_subscription_id"
              >
              <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.user_subscription_id]"
                    v-model="userSubscriptionIds"
                  />
                </td>
                <td>{{ r.user_subscription_id }}</td>
                <td>{{ r.user_id }}</td>
                <td>{{ r.full_name }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.subscription_name }}</td>
                <td>{{ r.type_name }}</td>
                <td
                  v-if="$_has_perm('delete_customer_subscription')"
                  style="padding-left:0px; padding-right:5px"
                >
                <a
                    v-if="$_has_perm('edit_subscription')"
                    style="color:#01579B"
                    tooltip="Edit Subscription"
                    @click="editCustomerSubscription(r)"
                  >
                    <i class="material-icons">edit</i>
                  </a>
                  <a
                    style="color:#DF0845FF"
                    tooltip="Delete Customer Subscription"
                    @click="deleteCustomerSubscription(r)"
                  >
                    <i class="material-icons">delete</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    phone_number="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <add-edit-user-subscription
            :addEditCustomerSubscriptionModal="addEditCustomerSubscriptionModal"
            :submitAddEditUserSubscription="submitAddEditUserSubscription"
            :closeAddEditCustomerSubscriptionModal="closeAddEditCustomerSubscriptionModal"
            :warehouses="warehouses"
            :orderTypes="orderTypes"
            :customers="customers"
            :subscriptions="subscriptions"
            :addEditData="addEditData"
            :checkAlert="checkAlert"
            :validationError="validationError"
          ></add-edit-user-subscription>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination'
import preDatatableComponent from '../preDatatableComponent'
import DatatableVue from '../Datatable'
import addEditUserSubscription from './addEditUserSubscription.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'add-edit-user-subscription': addEditUserSubscription
  },
  created() {
    if (this.queryParameter === true) {
      if (
        window.location.search.replace('?name=', '') !== null ||
        window.location.search.replace('?name=', '') !== ''
      ) {
        let value = window.location.search.replace('?name=', '')
        this.searchOneCol('full_name', value)
      }
    }
    this.getResults()
  },
  mounted() {
    this.getCustomer()
    this.getWarehouses()
    this.getSubscriptions()
    this.getOrderTypes()
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      { label: 'ID', text: 'ID', value: '2', sortable: true, searchable: true, name: 'user_subscription_id' },
      {
        label: 'CID',
        text: 'CID',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'customer_id'
      },
      {
        label: 'Customer',
        text: 'Customer',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'customer_name'
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'warehouses.country'
      },
      {
        label: 'Subscription',
        text: 'Subscription',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'subscription_name'
      },
      {
        label: 'Type',
        text: 'Type',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'order_types.type_name'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loading: false,
      url: 'api/customer-subscription',
      editStaffUrl: 'api/update-staff',
      getCustomerUrl: 'api/get-customer-to-select',
      addEditCustomerSubscriptionModal: false,
      rowIndex: '',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      checkAlert: false,
      validationError: false,
      backendError: false,
      queryParameter: true,
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      warehouses: [],
      customers: [],
      subscriptions: [],
      orderTypes: [],
      userSubscriptionIds: [],
      columns: columns,
      sortKey: 'user_subscription_id',
      sortOrders: sortOrders,
      addEditData: {},
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_subscription_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    changeActive(data) {
      let token = localStorage.getItem('access_token')

      axios.get(`api/warehouses/${data.warehouse_id}/toggle-active`, {
        headers: { Authorization: 'Bearer ' + token }
      })
        .then(() => {
          swal({
            title: 'Updated successfully',
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
        })
        .catch((error) => {
          swal('Error', error.response.data.message, 'error')
        })
    },

    getWarehouses() {
      this.warehouses = []
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data.data
          result.forEach(r => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getCustomerUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.customersResult = response.data.data
          this.customersResult.forEach((c) => {
            this.customers.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    getSubscriptions() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/subscriptions', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.subscriptionResult = response.data.data
          this.subscriptionResult.forEach((c) => {
            this.subscriptions.push({
              text: c.subscription_name,
              value: c.subscription_id
            })
          })
        })
    },

    getOrderTypes() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/order-types', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.orderTypesResult = response.data.data
          this.orderTypesResult.forEach((c) => {
            this.orderTypes.push({
              text: c.type_name,
              value: c.order_type_id
            })
          })
        })
    },

    getResults(url = this.url) {
      let token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_subscription_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_subscription_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.sortByColumn()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_subscription_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_subscription_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    openAddEditCustomerSubscriptionModal() {
      this.addEditCustomerSubscriptionModal = true
    },

    closeAddEditCustomerSubscriptionModal() {
      this.addEditCustomerSubscriptionModal = false
      this.validationError = false
      this.checkAlert = false
      this.clear()
    },

    clear() {
      this.addEditCustomerSubscriptionModal = false
      this.addEditData = {
        warehouse_id_fk: [],
        order_type_id_fk: [],
      }
      this.$validator.reset()
      this.unCheckAll()
    },

    submitAddEditUserSubscription() {
      let token = localStorage.getItem('access_token')

      const isEditing = this.addEditData.user_subscription_id
      const method = isEditing ? 'patch' : 'post'
      const url = isEditing ? `${this.url}/${this.addEditData.user_subscription_id}` : this.url

      axios[method](url, this.addEditData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.validationError = false
          this.checkAlert = true
          this.getResults()
          this.clear()
        })
        .catch(error => {
          if (error.response.data.message) {
            this.checkAlert = false
            this.validationError = true
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    editCustomerSubscription(r) {
      console.log(r.user_id)
      this.addEditData = {
        user_subscription_id: r.user_subscription_id,
        customer_id_fk: r.user_id,
        warehouse_id_fk: [r.warehouse_id_fk],
        subscription_id: r.subscription_id_fk,
        order_type_id_fk: [r.order_type_id_fk],
        order_shipzone_fee: r.order_shipzone_fee,
        shiponly_handling_fee_air: r.shiponly_handling_fee_air,
        shiponly_handling_fee_sea: r.shiponly_handling_fee_sea,
        item_price_air: r.item_price_air,
        item_price_sea: r.item_price_sea,
        item_price_land: r.item_price_land
      }
      this.openAddEditCustomerSubscriptionModal()
      this.$validator.reset()
    },

    deleteCustomerSubscription(item) {
      swal({
        title: 'Are you sure?',
        text: `Delete customer subscription: ${item.subscription_name}?`,
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.url + '/' + item.user_subscription_id, { headers: { Authorization: 'Bearer ' + token } })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    deleteAllCustomerSubscription() {
      if (this.userSubscriptionIds.length === 0) {
        swal({
          text: 'Please select at least one customer subscription to delete',
          icon: 'warning',
          dangerMode: true
        })
        return
      }
      swal({
        title: 'Are you sure?',
        text: `Delete all selected customer subscriptions?`,
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .post(this.url + '/bulk-delete',
              { ids: this.userSubscriptionIds },
              { headers: { Authorization: 'Bearer ' + token } }
            )
            .then(response => {
              this.getResults()
              this.unCheckAll()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
      $('#mainCheck').prop('checked', false)
      this.userSubscriptionIds = []
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.btn {
  transition: all 0.5s;
}

.customer-subscription-table th[data-v-7aa7ac64] span {
  white-space: pre-line;
  text-align: center;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a.disabled {
  pointer-events: none;
  color: gray;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user_subscription/userSubscription.vue